import _ from 'lodash'
import React, { useState, useEffect } from 'react'
import { Tree } from 'antd'
import { http } from '@ud/admin-framework'

const { TreeNode } = Tree

const DepartmentTree: React.FC<IDepartmentTreeProps> = (props) => {
  const [list, setList] = useState<any[]>([])
  const [treeData, setTreeData] = useState<any[]>([])
  const [expandedKeys, setExpandedKeys] = useState<string[]>([])
  const [selectedNodeKeys, setSelectedKeys] = useState<string[]>([])
  const [autoExpandParent, setAutoExpandParent] = useState<boolean>(true)

  const getTreeData = () => {
    http.get('/manage/org/query/orgUnitTree', { params: { dimensionCode: 'DEFAULT' } }).then((res) => {
      const data = renderTreeNode([res.data])
      console.log(res.data)
      setList([res.data])
      setTreeData(data)
    })
  }

  useEffect(() => {
    getTreeData()
  }, [])

  const onExpand = (expandedKeys: any[]) => {
    setExpandedKeys(expandedKeys)
    setAutoExpandParent(false)
  }

  const selectNode = (selectedKeys: any[], e: any) => {
    if (selectedKeys.length > 0) {
      setSelectedKeys(selectedKeys)
      let item: any = null
      const recursive = (arr: any[], key: string) => {
        arr.forEach((v) => {
          if (v.uid === key) {
            item = v
          } else {
            if (_.isArray(v.children) && v.children.length > 0) {
              recursive(v.children, key)
            }
          }
        })
      }
      recursive(list, selectedKeys[0])
      props.selectTreeNode && props.selectTreeNode(selectedKeys[0], item)
    }
  }

  const renderTreeNode = (nodes: any[]) => {
    return nodes.map((v: any, i: number) => {
      if (v.children) {
        return (
          <TreeNode key={v.uid} title={v.name}>
            {renderTreeNode(v.children)}
          </TreeNode >
        );
      }
      return <TreeNode key={v.uid} title={v.name} />;
    })
  }

  return (
    <Tree
      onExpand={onExpand}
      expandedKeys={expandedKeys}
      selectedKeys={selectedNodeKeys}
      autoExpandParent={autoExpandParent}
      onSelect={selectNode}
    >
      {treeData}
    </Tree>
  )
}

interface IDepartmentTreeProps {
  nodes?: any
  selectTreeNode?: any
}

export default DepartmentTree